
import styled from "styled-components";

export const ModalWrapper = styled.div`
  .modal-dialog.video-modal {
    --bs-modal-width: 750px !important;
  }

  .modal-dialog.image-modal {
    --bs-modal-width: 650px !important;
  }

  @media (max-width: 768px) {
    .modal-dialog.video-modal,
    .modal-dialog.image-modal {
        --bs-modal-width: 100vw;
      height: 100vh !important;
    }
  }
`;

export const PopupContainer = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  & hr{
    opacity: 0.15;
    margin-top:0;
  }
  & .customAlertStyle {
    background-color: #d4edda;
    color: #155724;
    font-family: sans-serif;
    text-align: center;
    width: max-content;
    position: absolute;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    padding: 8px 16px;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
  height: ${props => props?.isVideo ? "81vh" :props?.ispdf ? "" : "88vh"};
  padding:2.2rem 1.85rem 2.85rem;
  @media (max-width: 750px) {
    height: 97vh;
    max-width: 100%;
    border-radius: 0;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    height: ${props => props?.isVideo ? "60vh" : props?.ispdf ? "" : "70vh"};
    padding:2.2rem 1.85rem;
  }
  @media only screen and (min-width:1600px) and (max-width:1920px){
    height: ${props => props?.isVideo ? "65vh" : props?.ispdf ? "" : "72vh"};
  }
  @media only screen and (min-width:1200px) and (max-width:1400px){
    height: ${props => props?.isVideo ? "86vh" : props?.ispdf ? "" : "89vh"};
  }
  @media screen and (min-width: 1440px) and (max-width: 1440px) and (min-height: 900px) and (max-height: 900px) {
    height: ${props => props?.isVideo ? "67vh" : props?.ispdf ? "" : "73vh"};
  }
`;

export const WelcomePopupContainer = styled(PopupContainer)`
  height: auto;
`

export const MediaWrapper = styled.div`
  width: 100%;
  position:relative;
  height: ${props => props?.isVideo ? "" : "50vh"};
  @media only screen and (min-width:1200px) and (max-width:1400px){
    height: ${props => props?.isVideo ? "" : "57vh"};
  }
  @media only screen and (min-width:1400px) and (max-width:1600px){
    height: ${props => props?.isVideo ? "" : "62vh"};
  }
  @media screen and (min-width: 1440px) and (max-width: 1440px) and (min-height: 900px) and (max-height: 900px) {
    height: ${props => props?.isVideo ? "" : "51vh"};
  }
`;

export const MediaItem = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  overflow: hidden;

  // Blurred background image
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: ${({ imageSrc }) => `url(${imageSrc})`};
    background-size: cover;
    background-position: center;
    filter: blur(10px);
    -webkit-filter: blur(10px);
    transform: scale(1.1);
    z-index: 0;
  }
  & img {
    position: relative;
    z-index: 1;
    max-width: 100%;
    object-fit: contain;
    height:100%;
    border-radius:10px;
    @media (max-width: 750px) {
      height:100%;
      max-width: 100%;
      border-radius: 10px;
    }
  }
  // Video styling remains unchanged
  & video {
    position: relative;
    z-index: 1;
    max-width: 100%;
    object-fit: contain;
    height:350px;
    border-radius:10px;
    background-color:#000;
    @media only screen and (min-width:1200px) and (max-width:1400px){
      height: 300px;
    }
  }
`;

export const PrevButton = styled.button`
  position: absolute;
  top: 45%;
  left: -1rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 2;
  
&:disabled {
    cursor: not-allowed;
  }

`;

export const NextButton = styled.button`
  position: absolute;
  top: 45%;
  right: -1rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 2;
  &:disabled {
    cursor: not-allowed;
  }
`;

export const ButtonsWrapper = styled.div`
    position:relative;
    width: auto;
    display:flex;
    flex-direction:row;
    margin-left:auto;
`;

export const SaveButtonContainer = styled.div`
    cursor: pointer;
    width: auto;
    font-size: 20px;
    padding: 10px 2rem 0 0px;
    display:flex;
    justify-content:center;
    align-items: center;
    & img{
      width:17px;
        @media screen and (min-width: 1200px) and (max-width:1400px){
            min-height:22px;
            margin-right:5px;
        }
    }
    @media screen and (max-width: 750px){
        padding: 5px 1rem 0 0px;
    }
    .save-share-icon{
        margin-right:0px;
        width:20px;
        height:30px;
    }
    .save-share-text {
        font-family: Lato;
        font-weight: 700;
        font-style: Bold;
        font-size: 16px;
        line-height: 120%;
        color: #FF6B00;
        padding-left:7px;
        @media screen and (max-width: 750px){
            width: 100%;
            display: block;
        }
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait){
          left: 0vw;
        }
    }
`;

export const AddCloseIcon = styled.div`
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    cursor: pointer;
    margin-top: ${props => props?.connecttour ? "0" : "10px"};
    margin-right: ${props => props?.connecttour ? "5px" : "10px"};
    position: absolute;
    right: 0px;
`

export const ModalCloseCTA = styled.button`
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  cursor: pointer;
  margin-top: 10px;
  margin-right: 10px;
  position: absolute;
  right: 0px;
  cursor: pointer;
  background: none;
  border: none;
  cursor: pointer;
  z-index:2;
  @media only screen and (max-width:750px){
    margin-right: 5px;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    margin-right: 11px;
    top:3px;
  }
`

export const Metadata = styled.div`
  margin: 16px 0 5px;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 350px;
`;

export const MediaTitle = styled.div`
    font-family: Lato;
    font-weight: 700;
    font-style: Bold;
    font-size: 20px;
    line-height: 120%;
    padding: 0.25rem 0;
    color:#000;
`;

export const MediaDate = styled.div`
    color:#000;
    font-family: Lato;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    line-height: 135%;
    letter-spacing: 1%;

`;
export const Title = styled.h4`
  margin: 0;
`;

export const DateText = styled.span`
  font-size: 0.9rem;
  color: gray;
`;

export const IconGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const DescriptionWrapper = styled.div`
  margin-top: 10px;
`;

export const DescriptionText = styled.p`
  margin: 0;
  white-space: pre-wrap;
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const CarouselItem = styled.div`
  display: ${props => (props.active ? "block" : "none")};
  width: 100%;
  height: 100%;
`;

export const MediaImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const MediaVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  color: white;
  border: none;
  font-size: 2rem;
  padding: 0 10px;
  cursor: pointer;
  z-index: 1;
  &:first-of-type {
    left: 10px;
  }
  &:last-of-type {
    right: 10px;
  }
`;


// Styled Components
export const ModalContent = styled.div`
  padding: 30px;
  text-align: center;
  position: relative;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: ${props => (props.isVideo ? "14%" : "23%")};
  margin: 0 auto;
  @media only screen and (min-width:1200px) and (max-width:1400px){
    width: ${props => (props.isVideo ? "12%" : "18%")};
  }
  @media only screen and (max-width:750px){
    width:30%;
  }
  img {
    width:100%;
  }
`;

export const HeadingTitle = styled.h4`
  justify-content: center;
  align-items: center;
  display: flex;
  font-family: Lato;
  font-weight: 400;
  font-style: Regular;
  font-size: ${props => (props.isVideo ? "24px" : "28px")};
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  margin:1rem;
  @media only screen and (min-width:1200px) and (max-width:1400px){
    font-size: 22px;
    margin:0.7rem;
  }
`;

export const Guidelines = styled.div`
  font-family: Lato;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 1%;
  margin: ${props => (props.isShare ? "1rem 0 1.5rem" : "0.5rem 0")};
  color:#111111;
  height: ${props => (props.isShare ? "25vh" : "")};
  overflow-y: ${props => (props.isShare ? "auto" : "")};
  @media only screen and (min-width:1200px) and (max-width:1400px){
    margin: ${props => (props.isShare ? "0rem 0 1.5rem" : "0.5rem 0")};
    font-size: 14px;
  }
  @media only screen and (max-width:750px){
    margin: ${props => (props.isShare ? "0rem 0" : "0.5rem 0")};
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {
    margin: ${props => (props.isShare ? "1rem 0" : "0.5rem 0")};
    height: ${props => (props.isShare ? "20vh" : "")};
  }
  p {
    margin-bottom:1rem;
    padding-left:1.25rem;
    position:relative;
    &::before {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      left: 0px;
      top: 13%;
      border-radius: 100%;
      background-color: #FF6B00;
    }
  }
`;
export const ShareContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  // @media (min-width: 768px) {
  //   flex-direction: row;
  // }
`;

export const InputCol = styled.div`
  flex: 1;
`;

export const IconCol = styled.div`
  flex: 1;
`;

export const InputRow = styled.div`
  display: flex;
  justify-content: center;
  align-items:center;
  margin-bottom: 5px;
  position: relative;
  margin-top: 5px;
  input {
    width: 100%;
    min-height: 46px;
    padding: 8px;
    border: 2px solid #FF6B00;
    border-radius: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 5px;
  }
`;

export const BrowseButton = styled.button`
  padding: 8px 12px;
  background-color: orange;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
`;

export const IconRow = styled.div`
  display: flex;
  justify-content: center;
  align-items:center;
  gap: 30px;
  margin-bottom: 20px;
  @media only screen and (max-width:375px){
   margin-bottom: 0px;
  }

  .icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  img {
    width: 32px;
    cursor: pointer;
    margin-bottom: 5px;
  }

  span {
    font-size: 14px;
    color: #333;
  }
`;

export const ShareText = styled.span`
font-size: 16px;
font-family:"Lato-Bold";
`
export const PrimaryButton = styled.button`
  padding: 10px 20px;
  background-color: #FF6B00;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  font-family: Lato;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  width:65%;
  margin:1rem auto 1rem;
  box-shadow: 0px 3px 0px 0px #C75300;
  @media only screen and (min-width:1200px) and (max-width:1400px){
    margin:0rem auto 0rem;
    width:${props => (props.isVideo ? "50%" : "65%")};
  }
  @media only screen and (max-width:750px){
    width:100%;
  }
`;
export const CopyButton = styled.button`
  padding: 10px 10px;
  background-color: #FF6B00;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  font-family: Lato;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  width:20%;
  margin:1rem 1rem;

  @media only screen and (min-width:1200px) and (max-width:1400px){
    margin:0rem auto 0rem;
  }
  @media only screen and (max-width:750px){
    width:100%;
  }
`;